
import React from 'react';
import {
  Paper,
  Container,
  Grid
} from '@mui/material';
import { useSelector } from 'react-redux';
import LeftSection from '../molecule/leftSection';
import RightSection from '../molecule/rightSection';

const TranslationService = () => {
  const step = useSelector((state: any) => state.translation.currentStep);
  
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2 }}>
        <Grid container spacing={{ xs: 2, md: 4 }}>
          {/* Left Panel */}
          <LeftSection step={step} />
          {/* Right Panel */}
          <RightSection step={step} />
        </Grid>
      </Paper>
    </Container>
  );
};

export default TranslationService;